<template>
	<div class="edit">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<el-form ref="form" :model="form" label-width="80px" class="formCommit edits">
			<div class="edit-title">{{editTitle}}</div>
			<div class="edit-num">投稿编号：{{editNum}}</div>
			<el-form-item label="设计师" >
				<el-input v-model="form.author" class="inputName" :disabled='disable'></el-input>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Istitle'>作品名字不能超出30个中文</span><span v-show='IstitleNull'>作品名字不能不能为空</span></span>
			</el-form-item>
			<el-form-item label="游戏定位">
				<el-select v-model="form.location" placeholder="请选择游戏定位" class="inputName" :disabled='updatas'>
					<el-option label="儿童游戏" value="1"></el-option>
					<el-option label="家庭游戏" value="2"></el-option>
					<el-option label="进阶游戏" value="3"></el-option>
					<el-option label="重度游戏" value="4"></el-option>
				</el-select>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Islocation'>游戏定位不能为空</span></span>
			</el-form-item>
			<el-form-item label="游戏分类">
				<el-select v-model="form.type" placeholder="请选择游戏分类" class="inputName" :disabled='updatas'>
					<el-option label="抽象游戏" value="1"></el-option>
					<el-option label="策略游戏" value="2"></el-option>
					<el-option label="卡牌游戏" value="3"></el-option>
					<el-option label="聚会游戏" value="4"></el-option>
					<el-option label="骰子游戏" value="5"></el-option>
					<el-option label="合作游戏" value="6"></el-option>
					<el-option label="主题游戏" value="7"></el-option>
					<el-option label="其他游戏" value="8"></el-option>
				</el-select>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show="Istype">游戏分类不能为空</span></span>
			</el-form-item>
			<el-form-item label="游戏时长">
				<el-select v-model="form.time_game" placeholder="请选择游戏时长" class="inputName" :disabled='updatas'>
					<el-option label="0-15分钟" value="1"></el-option>
					<el-option label="16-30分钟" value="2"></el-option>
					<el-option label="31-60分钟" value="3"></el-option>
					<el-option label="61-120分钟" value="4"></el-option>
					<el-option label="120分钟以上" value="5"></el-option>
				</el-select>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show="Istime">游戏时长不能为空</span></span>
			</el-form-item>
			<el-form-item label="合适年龄" class='floatRight float1'>
				<el-select v-model="form.age" placeholder="请选择合适年龄" class="inputName" :disabled='updatas'>
					<el-option label="4岁以上" value="1"></el-option>
					<el-option label="6岁以上" value="2"></el-option>
					<el-option label="10岁以上" value="3"></el-option>
					<el-option label="14岁以上" value="4"></el-option>
					<el-option label="18岁以上" value="5"></el-option>
				</el-select>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show="Isage">合适年龄不能为空</span></span>
			</el-form-item>
			<el-form-item label="游戏人数" class='floatRight float2'>
				<el-input v-model="form.players_down" class="inputName1" :disabled='updatas'></el-input><span>至&nbsp;&nbsp;&nbsp;&nbsp;</span>
				<el-input v-model="form.players_up" class="inputName1" :disabled='updatas'></el-input>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Isplayers'>请重新填写游戏人数</span></span>
			</el-form-item>
			<el-form-item label="国家地区" class='floatRight float3'>
				<el-input v-model="form.country" class="inputName" :disabled='disable'></el-input> 
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Isplayers'>请重新国家地区</span></span>
			</el-form-item>
			<el-form-item label="投稿日期" class='floatRight float4'>
				<el-date-picker :disabled='disable' type="date" placeholder="选择日期" v-model="form.updated_at" class="inputName right"></el-date-picker>
				<span class="rules"><img src="../assets/img/xing.png"/><span v-show='Istitle'>作品名字不能超出30个中文</span><span v-show='IstitleNull'>作品名字不能不能为空</span></span>
			</el-form-item>
			<el-form-item label="游戏测试文件" class='more-width'>
				<a :href='form.filelink' v-html='form.filename' class="filedown"></a>
			</el-form-item>
			<el-form-item label="实物样品快递/邮寄编号" class='express more-width'>
				<span v-html='form.expresst'></span>
			</el-form-item>
		</el-form>
		<el-upload class="upload-demo" :action="uploadHost" :file-list="fileList" :on-success="handleSuccess" :data="ossParams" :on-change="handleChange" :disabled='disabled' :beforeUpload="beforeAvatarUpload" :on-remove="handleRemove" :limit=1>
			<el-button type="primary" :disabled='disabled' round>说明文档上传</el-button>
		</el-upload>
		<p class="introduction"><span class="introductionSpan">游戏介绍  &nbsp;</span></p>
		<textarea name="" rows="20" cols="110" class="shuoming" v-model="form.introduction" :disabled='updatas'></textarea>

		<el-table align='center' :data="tableData" style="width: 100%;margin: 25px auto;width: 630px;border-radius: 15px;margin-bottom: 20px;">
			<el-table-column prop="statusNum" label="审核状态" width="180">
				<template slot-scope="scope">
		        <span :style="{color:scope.row.color}" >{{ scope.row.statusNum }}</span>
		      </template>
			</el-table-column>
			<el-table-column prop="first_check_count" label="初审人数" width="180">
			</el-table-column>
			<el-table-column prop="play_count" label="试玩次数">
			</el-table-column>
			<el-table-column prop="second_check_count" label="复审人数">
			</el-table-column>
		</el-table>
        <div class="leaveMessage">
			<el-select v-model="type" placeholder="留言者身份" class="search">
		      <el-option label="全部" value="0"></el-option>
		      <el-option label="投稿人留言" value="1"></el-option>
		      <el-option label="审核员留言" value="2"></el-option>
		    </el-select>
			<el-select v-model="sort" placeholder="排序" class="search search2">
		      <el-option label="按创建时间降序" value="1"></el-option>
		      <el-option label="按创建时间升序" value="2"></el-option>
		    </el-select>
		    <el-button type="primary" icon="el-icon-search" class="search search3" @click='search'>搜索</el-button>
		    
		    <div class="letter-div" v-for="(item,index) in items" :key='index'>
				<div class="div" :style="{boxShadow:'5px 5px 5px '+item.color}">
					<img class="personIcon" :src="imgUrl" v-if="item.type == 1"/>
					<img class="personIcon" src="../assets/img/admin.png" v-else/>
					<p class="time">{{item.created_at}} <span @click="replay(item)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
					<div class="rightMsg">
						<div v-if="item.type == 1" class="anname">我</div>
						<div v-else class="anname"><span>管理员 </span> | <span>{{item.checker}} </span></div>
					    <p class="msgOver" v-for="msg in item.message">{{msg}}</p>

					    <!--子循环-->
					    <div class="letter-div-1" v-for="(child,index) in item.child" :key='index'>
							<div class="div1">
								<img class="personIcon" :src="imgUrl" v-if="child.type == 1"/>
								<img class="personIcon" src="../assets/img/admin.png" v-else/>
								<p class="time">{{child.created_at}} <span @click="replay(item)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
								<div class="rightMsg1">
									<div v-if="child.type == 1" class="morename">我</div>
									<div v-else class="morename"><span>管理员 </span> | <span>{{child.checker}} </span></div>
								    <p class="msgOver1" style="cursor: auto;" v-for="childMsg in child.message">{{childMsg}}</p>
								</div>				
							</div>			
						</div>
					</div>				
				</div>			
			</div>
			<el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange"  :page-size="pageSize"  layout="prev, pager, next, jumper"  :total="total" class="pagination" style="text-align: center;"></el-pagination>
			<form :data-current="currentIndex" :data-action="actionType">
		        <el-input type="textarea" v-model="content" class="inputName area" rows="5" data-index="0" :disabled='leaveWord'></el-input>
		   </form>
			<el-button type="primary" round class="commitFirst" @click="commit" :disabled='leaveWord'>提交留言</el-button>
		</div>
		<div class="bottom-btn">
			<el-button type="primary" round class='btn' @click='edit' :disabled='updatas'>保存修改</el-button>
			<el-button type="primary" round class='btn' @click='handdelete' :disabled='recalls'>撤回投稿</el-button>
		</div>
		<div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	export default {
		data() {
			return {
				formLabelWidth: '120px',
				Isflow: true,
				form: {
					title: '',
					location: '3',
					type: '',
					age: '',
					time_game: '',
					players_down: '',
					players_up: '',
					introduction: '',
					is_agree: '1',
					first_checkfile: '',
					author: '',
					filename:'',
					filelink:'',
					expresst:''

				},
				fileList: [],
				uploadHost: process.env.BASE_URL + '/oss/get-sign?type=2',
				ossParams: {
					key: '', // key后面有用，先默认设空字符串
					success_action_status: '200', // 默认200
				},
				picOSS: false,
				dir: '',
				Istitle: false,
				Islocation: false,
				Istype: false,
				Istime: false,
				Isage: false,
				Isplayers: false,
				IstitleNull: false,
				tableData: [],
				disabled:false,
				disable:true,
				updatas:false,//是否允许修改
				leaveWord:false,//是否允许留言
				recalls:false,//是否允许撤回
				editTitle:'',
				editNum:'',

				sort:'1',
				type:'0',
				items:[],
				content:'',
				data:'',
				reply:false,
				id:0,
				children:[],
				i:0,
				pageSize:2,
				page:1,
				total:0,
				show:false,
				focusCtrl: 0,  // 自动聚焦控制,变动时,执行自动聚焦指令
                currentIndex: 0, // 当前聚焦元素的索引
                actionType: 'next', // 自动聚焦的行为类型
			}
		},
		computed:{
			...mapGetters([
					'imgUrl','name'
			]),
		},
		watch:{
			content:function(){
				if(this.content.length > 1500){
					this.$nextTick(function(){
						this.content = this.content.substr(0,1500)
					})
				}
			}
		},
		created() {			
			axios({
				method: 'post',
				url: process.env.BASE_URL + '/apply/detail?id=' + this.$route.query.id,
				withCredentials: true,
			}).then(res => {
				this.editTitle = unescape(res.data.data.apply.title)
				this.editNum = res.data.data.apply.num_order
				this.form = res.data.data.apply
				this.form.introduction = unescape(this.form.introduction);
				this.form.title = unescape(this.form.title);

				var data = res.data.data.apply
				data.introduction = unescape(data.introduction);
				data.title = unescape(data.title);

				this.form.location = data.location.toString() 
				this.form.time_game = data.time_game.toString() 
				this.form.age = data.age.toString() 
				this.form.type = data.type.toString() 

				// console.log('aaa:',unescape(this.form.introduction))

				if(data.file == ''){
                    this.form.filename = '未提交'
                    this.form.filelink = 'javascript:;'
				}else{
					this.form.filename = process.env.BASE_URL +'/'+ data.file
					this.form.filelink = process.env.BASE_URL +'/'+ data.file
				}
                if(data.express_no == ''){
                   this.form.expresst = '未提交'
				}else{
					this.form.expresst = data.express_no
				}
				if(data.status == '1'){
					data.statusNum = '初审已提交'
					data.color = 'black'
					this.activeColor = data.color
					this.disabled = false
				}
				if(data.status == '2'){
					data.statusNum = '初审中'
					data.color = '#D4AD25'
					this.activeColor = data.color
					this.disabled = false
					this.recalls = true
				}
				if(data.status == '3'){
					data.statusNum = '初审已通过'
					data.color = '#4DC55E'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.recalls = true
				}
				if(data.status == '4'){
					data.statusNum = '复审已受理'
					data.color = '#A84FF4'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.recalls = true
				}
				if(data.status == '5'){
					data.statusNum = '复审中'
					data.color = '#D4AD25'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.recalls = true
				}
				if(data.status == '6'){
					data.statusNum = '复审已通过'
					data.color = '#4DC55E'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.recalls = true
				}
				if(data.status == '7'){
					data.statusNum = '未通过'
					data.color = '#E13333'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.leaveWord = true
					this.recalls = true
				}
				if(data.status == '8'){
					data.statusNum = '已撤回'
					data.color = 'black'
					this.activeColor = data.color
					this.disabled = true
					this.updatas = true
					this.leaveWord = true
					this.recalls = true
				}
				this.tableData.push(res.data.data.apply)				
				this.fileList.push({name:data.first_checkfile,url:'http://sgs-dl.oss-cn-shanghai.aliyuncs.com/'+ data.first_checkfile})
				this.dir = data.first_checkfile
			})
			this.data =this.$route.query.id 
			this.init(this.sort,this.type,this.page,this.pageSize)
			this.$store.commit('SET_ISBLUEACTIVE', true)
			this.$store.commit('SET_ISBLUECOLOR', true)
//			this.$store.commit('SET_ADMINLEFTNAVNUM','/message/privateLetter')
//			this.$store.commit('SET_ADMINLEFTNAVNUM','/person/information')
		},
		methods: {
			handleSuccess(res, file) {
			  this.dir = res.dir + file.name
			  var form3 = new FormData
			  form3.append('name',file.name)
			  form3.append('key',res.dir+'${filename}')
			  form3.append('policy',res.policy)
			  form3.append('OSSAccessKeyId',res.accessid)
			  form3.append('success_action_status','200')
			  form3.append('signature',res.signature)
			  form3.append('file',file.raw)
			  axios({
			  	method:'post',
			  	url:res.host,
			  	data:form3,
			  	withCredentials:false
			  })
			  .then(res =>{
			  	 this.picOSS = true
			  })
			},
			handleChange(file, fileList){
				 this.fileList = fileList.slice(-1)
			},
		    // 上传前对文件的大小的判断
		    beforeAvatarUpload (file) {
		      const isLt2M = file.size / 1024 / 1024 < 2
		      if (!isLt2M) {
		        this.$confirm('上传说明文档大小不能超过20MB，请删除后重新上传！', '提示', {
		          confirmButtonText: '确定',
		          showCancelButton:false,
		          type: 'warning'
		        }).then(() => {
		          
		        }).catch(() => {
		                  
		        });
		      }
		      return isLt2M
		    },
		    handleRemove(file, fileList) {
		        this.dir = ''
		    },
			edit(){
				if(this.dir == ''){
					this.$message.error('说明文档为空或说明文档大小超过限制，请重新上传！')
					window.scrollTo(0,400);
					return;
				}
				var form5 = new FormData
				form5.append('id',this.form.id)
				form5.append('location',this.form.location)
				form5.append('type',this.form.type)
				form5.append('age',this.form.age)
				form5.append('time_game',this.form.time_game)
				form5.append('players_down',this.form.players_down)
				form5.append('players_up',this.form.players_up)
				form5.append('introduction',this.form.introduction)
				form5.append('first_checkfile',this.dir)
				form5.append('country',this.form.country)
				axios({
					method:'post',
					url:process.env.BASE_URL + '/apply/change',
					withCredentials:true,
					data:form5,
				})
				.then(res =>{
			  	    	this.$confirm(res.data.message, '提示', {
				          confirmButtonText: '确定',
				          showCancelButton:false,
				          type: 'info'
				        }).then(() => {
				          this.$router.push({path:'/person/edit?id=' + this.$route.query.id + ''})
				        }).catch(() => {
				                  
				        });
			    })
			},
			handdelete(){
				//撤回
                this.$confirm('此操作将撤回该投稿, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		            var form1 = new FormData
					form1.append('id',this.form.id)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/apply/recall',
						data:form1,
						withCredentials:true
					})
					.then(res =>{
						if (res.data.code == 10000) {
							this.$message({
					          message: res.data.message,
					          type: 'success'
					       });
					       this.$router.push({ path: 'manage'})
						} else{
							this.$message({
					          message: res.data.message,
					          type: 'warning'
					        });
						}
					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消撤回'
		          });          
		        });
				
			},
			init(sort,type,page,pageSize){
				var data = this.data
				axios({
					method:'get',
					url:process.env.BASE_URL+'/message/lists?aid='+data+'&sort='+sort+'&type='+type+'&page='+page+'&pageSize='+pageSize+'',
					// data:form,
					withCredentials:true
				}).then(res =>{
					this.items = res.data.data.rows.slice((page-1)*pageSize,page*pageSize)
					var strs = new Array()
					var childs = new Array()
					for (var i = 0; i < this.items.length; i++) {
						strs = this.items[i].message.split('\n')
						this.items[i].message = strs	
						if(this.items[i].child.length > 0){
							
							for (var j = 0; j < this.items[i].child.length; j++) {
								childs = this.items[i].child[j].message.split('\n')
								this.items[i].child[j].message = childs
							}
						}
						
					}
//					console.log(strs,childs)
					this.total = res.data.data.rows.length
				})
				
			},
			search(){
				this.init(this.sort,this.type,this.page,this.pageSize)
			},
			commit(){				
				if (this.reply == false) {					
					var form1 = new FormData
					form1.append('aid',this.data)
					form1.append('message',this.content)
					if(this.content.length > 0){
						this.$confirm('确认提交', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText:'取消',
				          type: 'info'
				        }).then(() => {
				        	axios({
								method:'post',
								url:process.env.BASE_URL+'/message/add',
								data:form1,
								withCredentials:true
							}).then(res =>{
								if(res.data.code == 10000){
									this.init(this.sort,this.type,this.page,this.pageSize)
								    this.content = ''
								}else{
									this.$confirm(res.data.message, '提示', {
							          confirmButtonText: '确定',
							          showCancelButton:false,
							          type: 'info'
							        }).then(() => {
							        }).catch(() => {
							                  
							        });
								}
								
							})
				        }).catch(() => {});
					}
					
				} else if (this.reply == true) {					
					var form2 = new FormData
					form2.append('id',this.id)
					form2.append('aid',this.data)
					form2.append('message',this.content)
					if(this.content.length > 0){
						this.$confirm('确认提交', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText:'取消',
				          type: 'info'
				        }).then(() => {
				        	axios({
								method:'post',
								url:process.env.BASE_URL+'/message/reply',
								data:form2,
								withCredentials:true
							}).then(res =>{
								if(res.data.code == 10000){
									this.init(this.sort,this.type,this.page,this.pageSize)
								    this.$message('回复成功')
								    this.content = ''
								}else{
									this.$confirm(res.data.message, '提示', {
							          confirmButtonText: '确定',
							          showCancelButton:false,
							          type: 'info'
							        }).then(() => {
							        }).catch(() => {});
								}
							})
				        }).catch(() => {});
					}
				}
			},
			replay(obj){
				this.reply = true
				this.id = obj.id
				if (obj.type == 1) {
					this.content = '@我: '
					// this.focusCtrl = 0
					this.currentIndex = 0
					// this.setFocus()
					// this.setFocusIndex()
				} else{
					this.content = '@管理员|'+obj.checker+': '
					// this.focusCtrl = 0
					this.currentIndex = 0
				}
				
			},
			list(item){	
				axios({
					method:'post',
					url:process.env.BASE_URL+'/message/reply-list?id='+item.id,
					withCredentials:true
				}).then(res =>{
					for (var i = 0; i < this.items.length; i++) {
						if (this.items[i].id == item.id) {
							this.i = i
						}
					}
					this.items[this.i].children = res.data.data.childMsg
					this.items.push()
				})
				if (item.change == true) {
					item.change = false					
				    this.items.push()
				} else if(item.change == false){
					item.change = true					
				    this.items.push()
				} else if(item.change == undefined){
					item.change = true
					this.items.push()
				}
				
			}/*,
			setFocus(actionType,index) {
                if (actionType === 'jump') {
                    this.currentIndex = index
                }
                this.focusCtrl++
                this.actionType = actionType
           },
            setFocusIndex(index) {
                this.currentIndex = index
            }*/,
            handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		       this.init(this.sort,this.type,val,this.pageSize)
		       this.page = val
		    }
		}
	}
</script>

<style scoped>
.filedown{ text-decoration: none; color: #77b1ee; float: left; width: 558px; line-height: 20px; padding-top: 10px; display: block; }
.express .el-form-item__label{ width: 200px; }
	.edit {
		padding-left: 20px;padding-top: 15px;
	}
	
	.inputName {
		width: 182px;
	}
	
	.inputName1 {
		width: 55px;
		padding-right: 20px;
	}
	
	.el-form-item {
		width: 350px;
	}
	
	.introduction {
		font-size: 26px;
		margin-left: 105px;
	}
	
	.bottom-btn {
		width: 100%;
		margin: 0 auto;
		text-align: center;
	}
	
	.btn {
		margin: 50px;
	}
	.right .el-input__prefix{
		left: 5px;
	}
	.formCommit{
		width: 750px;
		margin: 0px auto;
		padding: 25px;
	}
	.upload-demo{
		margin-top: 30px;
		margin-left: 105px;
		width: 630px;
	}
	.shuoming{
		margin-left: 105px;
		width: 630px;
	}
	.floatRight{
		float: right;
		margin-top: -250px;
		margin-right: 50px;
	}
	.float2{
		margin-top: -190px;
	}
	.float3{
		margin-top: -130px;
	}
	.float4{
		margin-top: -70px;
	}
	.edit-title{ font-size: 20px; font-weight: bold; padding-left: 60px;}
	.edit-num{ padding: 10px 0 40px 60px; }
	.leaveMessage{
		padding-top: 110px; position: relative;
	}
	.search{
		position: absolute;
		top: 60px;
		right: 140px;
		width: 160px;
	}
	.search2{
		right: 310px;
	}
	.search3{
		right: 40px;
		width: 90px;
	}
	.personIcon{
		width: 50px;
		height: 50px;
		float: left;
		padding: 10px;
	}
	.div{
		background: white;
		box-shadow: 3px 3px 3px #e7e7e7; border-left: 2px solid #ffcc80;
		position: relative;
		margin-top: 30px;
		width: 770px;
		margin-left: 35px; padding-bottom: 15px;
	}
	.rightMsg{
		width: 600px;
		margin-left: 90px; padding-top: 10px;		
	}
	.msgOver{
	    cursor: pointer;
	    width: 645px;
	    word-break: break-all;
	    overflow: hidden;
	    font-size: 14px;
	    color: #434242;
	    line-height: 21px; 
	}
	.msgOver:last-child{
		border-bottom: 1px dashed #eae6e6; padding-bottom: 10px;
	}
	.msgOver1{ font-size: 14px; color: #666;}
	.time{
		float: right; font-size: 14px; color: #9f9f9f; padding-right: 15px;
	}
	.time{
		float: right;
		margin-right: 10px;
	}
	.area{
		width: 770px;
		display: block;
		margin: 0 auto;
		margin-top: 50px;
	}
	.commitFirst{
		margin: 20px auto;
		text-align: center;
		display: block;
	}
	.pagination{
		padding-top: 30px;
		padding-left: 40px;
	}
	.active{
		overflow: auto;
		display: block;
	}	
	.msgOver1{
		cursor: pointer;
		word-break:break-all;
		display: -webkit-box;
	    -webkit-line-clamp: 100000;
	    -webkit-box-orient: vertical;
	}
	.div1{ overflow: hidden; position: relative; }
	.rightMsg1{ float: left; width: 525px; }
	.div1 .time{ position: absolute; right: 0; top: 0; padding: 0; }
	.letter-div-1{ border-bottom: 1px dashed #eae6e6; }
.answers{ width: 770px; margin: 25px auto 0; }
.morename{ padding-top: 10px; font-weight: bold; font-size: 14px;}
.anname{ color: #ffa229; }
textarea:disabled { background: #f5f7fa; border: 1px solid #dcdfe6; cursor: not-allowed;}
</style>


// WEBPACK FOOTER //
// src/views/edit.vue